module.exports = __webpack_public_path__ + "1b5cb74edbb6eb03920e7043892fc9bb.webp";